import React, { FC } from 'react';
import { useSetResponsiveNavigation } from '../../lib/hooks';
import { useTranslationsContext } from '../../lib/translation';

type Props = {
  navItems: INavItem[];
};

const MenuComponent: FC<Props> = ({ navItems }) => {
  const translations = useTranslationsContext();
  const ref = useSetResponsiveNavigation('.page__header .nav', 'header nav');

  const renderNavs = navItems.map((nav) => {
    const isActive = typeof nav.isActive === 'undefined' ? (window.location.pathname === nav.href || nav.childHrefs.includes(window.location.pathname)) : nav.isActive;
    return (
      <a key={nav.href} className={`nav__item${isActive ? ' nav__item--active' : ''}`} href={nav.href}>{nav.text}</a>
    );
  });

  return (
    <>
      {
        navItems.length > 0 && (
          <div ref={ref} className="nav__items">
            {renderNavs}
          </div>
        )
      }
      <button
        type="button"
        className="nav__toggle"
      >
        {translations.generics.navigation.local.toggle}
      </button>
    </>
  );
};

MenuComponent.displayName = 'MenuComponent';
export default MenuComponent;
